import { useEffect, useRef, useState } from "hono/jsx";

export function AttackMenu() {
  const menuRef = useRef<HTMLDialogElement>(null);
  const [_level, setLevel] = useState("hospital_lobby");

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        e.preventDefault();
        e.stopImmediatePropagation();

        const dialog = menuRef.current ||
          document.getElementById("attack-menu-dialog") as HTMLDialogElement;

        if (dialog?.open) {
          dialog.close();
        } else if (dialog) {
          dialog.showModal();
          document.exitPointerLock();
        }
      }
    };
    globalThis.addEventListener("keydown", handleKeyDown);
    return () => globalThis.removeEventListener("keydown", handleKeyDown);
  }, []);

  const changeLevel = (newLevel: string) => {
    setLevel(newLevel);
    // Send signal
    // We need access to the socket from state.ts, but imports here might be tricky if it's an island
    // We can dispatch an event that attack.ts listens to, or access window.state if we expose it
    document.dispatchEvent(
      new CustomEvent("attack:changeLevel", { detail: newLevel }),
    );
    menuRef.current?.close();
  };

  return (
    <dialog
      id="attack-menu-dialog"
      ref={menuRef}
      className="backdrop:bg-black/50 p-8 rounded-lg"
      style={{
        backgroundColor: "#222",
        color: "white",
        zIndex: 9999,
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        margin: 0, // Override default dialog margin
        minWidth: "300px",
        minHeight: "200px",
      }}
    >
      <h2 className="text-2xl font-bold mb-4">Level Select</h2>
      <div className="flex flex-col gap-2">
        <button
          type="button"
          className="btn"
          onClick={() => changeLevel("hospital_lobby")}
        >
          Hospital Lobby
        </button>
        <button
          type="button"
          className="btn"
          onClick={() => changeLevel("er_room")}
        >
          ER Room
        </button>
        <button
          type="button"
          className="btn btn-primary mt-2 uppercase italic font-black"
          onClick={() => {
            globalThis.dispatchEvent(new CustomEvent("attack:openCharacterSelect"));
            menuRef.current?.close();
          }}
        >
          Customize Character
        </button>
      </div>
      <div className="mt-4">
        <button
          type="button"
          className="btn btn-outline"
          onClick={() => menuRef.current?.close()}
        >
          Resume
        </button>
      </div>
    </dialog>
  );
}
